import axios from 'axios';

export default () => {
	return axios.create({
		baseURL: (window.apiUrl != null && window.apiUrl != '' && window.apiUrl != undefined ? window.apiUrl : '/api'),
		withCredentials: false,		
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		}
	})
}